/* eslint-disable @typescript-eslint/no-explicit-any */
import { Checkbox, Divider, Grid } from "@mui/material";

type PurchaseOrderProductsProps = {
  productId: any;
  product: any;
  quantity: any;
  stock: any;
  totalPrice: any;
  pricePerQuantity: any;
  styles: any;
  showDivider: boolean;
  checked: boolean;
  disabled: boolean;
  handleChangeSelectedProducts: (
    selectedAll: boolean,
    id: string | null
  ) => void;
};

export default function PurchaseOrderProducts(
  props: PurchaseOrderProductsProps
) {
  const {
    productId,
    product,
    quantity,
    stock,
    totalPrice,
    pricePerQuantity,
    styles,
    showDivider,
    checked,
    disabled,
    handleChangeSelectedProducts,
  } = props;

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={1} md={1} lg={1} className={styles}>
        <Checkbox
          disabled={disabled}
          checked={checked}
          onChange={(event) =>
            handleChangeSelectedProducts(productId ? false : true, productId)
          }
        />
      </Grid>
      <Grid item xs={3} md={3} lg={3} className={styles}>
        {product}
      </Grid>
      <Grid item xs={2} md={2} lg={2} className={styles}>
        {quantity}
      </Grid>
      <Grid item xs={2} md={2} lg={2} className={styles}>
        {stock}
      </Grid>
      <Grid item xs={2} md={2} lg={2} className={styles}>
        {totalPrice}
      </Grid>
      <Grid item xs={2} md={2} lg={2} className={styles}>
        {pricePerQuantity}
      </Grid>
      {showDivider ? (
        <Grid item xs={12} md={12} lg={12}>
          <Divider />
        </Grid>
      ) : null}
    </Grid>
  );
}
